/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipe_Show_TranslationInputs */

const en_recipe_show_translation = /** @type {(inputs: Recipe_Show_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show translation`)
};

const de_recipe_show_translation = /** @type {(inputs: Recipe_Show_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersetzung anzeigen`)
};

/**
* | output |
* | --- |
* | "Show translation" |
*
* @param {Recipe_Show_TranslationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_show_translation = /** @type {((inputs?: Recipe_Show_TranslationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_Show_TranslationInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_show_translation(inputs)
	return en_recipe_show_translation(inputs)
});